import { Actions } from '../../interfaces'

import find from './find'
import { Process } from '@/entities/settings'

export const actions: Actions = {
  find,
}

export default {
  Model: { Process },
  actions: { [Process.name]: actions },
}
